import { Box, Button, FormLabel, Grid, MenuItem, OutlinedInput, Select, Stack } from "@mui/material";
import { DataGridPremium, GridExcelExportMenuItem, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarExportContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "services/api";
import OpenOrderDetailPanel from "./OpenOrderDetailPanel";

const columns = [
  {
    field: "Owner",
    headerClassName: "headingbg-color",
    headerName: "Owner",
  },
  {
    field: "Warehouse",
    headerClassName: "headingbg-color",
    headerName: "Warehouse",
  },
  {
    field: "OrderNumber",
    headerClassName: "headingbg-color",
    headerName: "Order Number",
  },
  {
    field: "OrderRcvdDate",
    headerClassName: "headingbg-color",
    headerName: "Order Received Date",
  },
  {
    field: "orderType",
    headerClassName: "headingbg-color",
    headerName: "Order Type",
  },

  {
    field: "Priority",
    headerClassName: "headingbg-color",
    headerName: "Priority",
  },
  {
    field: "orderStatus",
    headerClassName: "headingbg-color",
    headerName: "Order Status",
  },
  {
    field: "TotalOrderLines",
    headerClassName: "headingbg-color",
    headerName: "Total Order Lines",
  },
  {
    field: "PiecesOrderd",
    headerClassName: "headingbg-color",
    headerName: "Pieces Ordered",
  },
  {
    field: "TotalShipped",
    headerClassName: "headingbg-color",
    headerName: "Total Shipped",
  },
  {
    field: "PiecesShipped",
    headerClassName: "headingbg-color",
    headerName: "Pieces Shipped",
  },
  {
    field: "RequestedShipDate",
    headerClassName: "headingbg-color",
    headerName: "Requested Ship Date",
  },
  {
    field: "ScheduledShipDate",
    headerClassName: "headingbg-color",
    headerName: "Scheduled Ship Date",
  },
  {
    field: "ActualShipDate",
    headerClassName: "headingbg-color",
    headerName: "Actual Ship Date",
  },
  {
    field: "CarrierCode",
    headerClassName: "headingbg-color",
    headerName: "Carrier Code",
  },
  {
    field: "CarrierName",
    headerClassName: "headingbg-color",
    headerName: "Carrier Name",
  },
  {
    field: "ExternalOrderNo",
    headerClassName: "headingbg-color",
    headerName: "External Order No",
  },
  {
    field: "BOLNumber",
    headerClassName: "headingbg-color",
    headerName: "BOL Number",
  },
  {
    field: "BillTo",
    headerClassName: "headingbg-color",
    headerName: "Bill To",
  },
  {
    field: "ShipTo",
    headerClassName: "headingbg-color",
    headerName: "Ship To",
  },
  {
    field: "ConsigneeAddress",
    headerClassName: "headingbg-color",
    headerName: "Consignee Address",
  },
  {
    field: "BuyerPOnumber",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
  },
  {
    field: "tracking_PROnumber",
    headerClassName: "headingbg-color",
    headerName: "Tracking PRO Number",
  },
  {
    field: "AppointmentNumber",
    headerClassName: "headingbg-color",
    headerName: "Appointment Number",
  },
  {
    field: "Door",
    headerClassName: "headingbg-color",
    headerName: "Door",
  },
  {
    field: "Route",
    headerClassName: "headingbg-color",
    headerName: "Route",
  },
  {
    field: "Stop",
    headerClassName: "headingbg-color",
    headerName: "Stop",
  },
  {
    field: "LoadNumber",
    headerClassName: "headingbg-color",
    headerName: "Load Number",
  },
  {
    field: "TrailerNumber",
    headerClassName: "headingbg-color",
    headerName: "Trailer Number",
  }
];

const OpenOrderReportTable = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = React.useState([]);
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [poNumber, setPONumber] = useState('');
  const [customerOrder, setCustomerOrder] = useState('');
  const [itemNum, setItemNum] = useState('');
  const [formStatus, setFormStatus] = useState('all');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [bolNumber, setBolNumber] = useState('');
  const [detailData, setDetailData] = React.useState([]);
  const [clearFormData, setClearFormData] = useState(false);

  const [statusMenu, setStatusMenu] = useState([])

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton slotProps={{ button: { sx: {fontSize:"14px"}} }}/>
        <GridToolbarFilterButton slotProps={{ button: { sx: {fontSize:"14px"}} }}/>
        <GridToolbarDensitySelector slotProps={{ button: { sx: {fontSize:"14px"}} }}/>
        {/* <GridToolbarExport /> */}
        <CustomExportButton slotProps={{ button: { sx: {fontSize:"14px"}} }}/>
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter/>
      </GridToolbarContainer>
    );
  }



  const exceljsPreProcess = async ({ workbook, worksheet }) => {
    // Set document meta data
    workbook.creator = 'MUI-X team';
    workbook.created = new Date();
    worksheet.name = "Open Orders"
    
    let worksheetMy = workbook.addWorksheet("Open Orders Details");

    
    worksheetMy.state = 'visible';

    worksheetMy.columns = [
      { header: 'Owner', key: 'Owner' },
      { header: 'Warehouse', key: 'Warehouse' },
      { header: 'Order Number', key: 'OrderNumber' },
      { header: 'Order Line No', key: 'orderLineNo' },
      { header: 'Order Detail ID', key: 'OrderDetailID' },
      { header: 'Item No', key: 'ItemNo' },
      { header: 'Item Description', key: 'ItemDescription' },
      { header: 'Orginal Qty', key: 'ORIGINALQTY' },
      { header: 'Open Qty', key: 'OPENQTY' },
      { header: 'Shipped Qty', key: 'SHIPPEDQTY' },
      { header: 'Adjusted Qty', key: 'ADJUSTEDQTY' },
      { header: 'Qty Allocated', key: 'QTYALLOCATED' },
      { header: 'Qty Picked', key: 'QTYPICKED' },
      { header: 'UOM', key: 'UOM' },
      { header: 'Pack Key', key: 'PACKKEY' },
      { header: 'Product Weight', key: 'PRODUCT_WEIGHT' },
      { header: 'Product Cube', key: 'PRODUCT_CUBE' },
      { header: 'Actual Ship Date', key: 'ACTUALSHIPDATE' },
      { header: 'Buyer PO', key: 'BUYERPO' },
      { header: 'Fullfill Qty', key: 'FULFILLQTY' },
      { header: 'Processed Qty', key: 'PROCESSEDQTY' },
      { header: 'Qty To Process', key: 'QTYTOPROCESS' },
      { header: 'SPS Tracking Number', key: 'SPSTrackingNumber' },
    ];

    worksheetMy.addRows(detailData);
  
    // Customize default excel properties
    worksheet.properties.defaultRowHeight = 30;
  
    // Create a custom file header
    // worksheet.mergeCells('A1:C2');
    // worksheet.getCell('A1').value =
    //   'This is an helping document for the MUI-X team.\nPlease refer to the doc for up to date data.';
  
    // worksheet.getCell('A1').border = {
    //   bottom: { style: 'medium', color: { argb: 'FF007FFF' } },
    // };
  
    // worksheet.getCell('A1').font = {
    //   name: 'Arial Black',
    //   size: 14,
    // };
    // worksheet.getCell('A1').alignment = {
    //   vertical: 'top',
    //   horizontal: 'center',
    //   wrapText: true,
    // };
    // worksheet.addRow([]);
  };
  const exceljsPostProcess = async ({ worksheet }) => {
    // // add a text after the data
    // worksheet.addRow({}); // Add empty row
  
    // worksheet.addRow(['Those data are for internal use only']);
  };
  
  const excelOptions = {
    exceljsPreProcess,
    exceljsPostProcess,
  };

  function CustomExportButton(props) {
    return (
      <GridToolbarExportContainer {...props}>
       <GridExcelExportMenuItem options={excelOptions}/>
      </GridToolbarExportContainer>
    );
  }

  const fetchTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    let payload = {
      custCode: userSetting?.[0]?.currCustomer,
      whseCode: userSetting?.[0]?.currWarehouse,
      from_orderRcvdDt: startDate.format("YYYY-MM-DD"),
      to_orderRcvdDt: endDate.format("YYYY-MM-DD"),
      poNumber: poNumber ? poNumber : 'all',
      custOrderNumber: customerOrder ? customerOrder: 'all',
      trackingNumber: trackingNumber ? trackingNumber : 'all',
      bolNumber: bolNumber ? bolNumber :'all',
      itemNumber: itemNum ? itemNum :'all',
      orderStatus: formStatus ? formStatus :'all',
    };
    const response = await postRequest(
      "user/getRprt_openOrders_forExcelExport",
      payload,
      headers
    );
    setData(response.data.Payload.Table);
    setClearFormData(false);
    setDetailData(response.data.Payload.Table1)
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTableData();
  }, [startDate, endDate, userSetting]);

  const rows = data.map((c, index) => ({
    id: index,
    Owner: c.Owner,
    Warehouse: c.Warehouse,
    OrderNumber: c.OrderNumber,
    OrderRcvdDate: c.OrderRcvdDate,
    OrderDate: c.OrderDate,
    orderType: c.orderType,
    Priority: c.Priority,
    orderStatus: c.orderStatus,
    TotalOrderLines: c.TotalOrderLines,
    TotalOrdered: c.TotalOrdered,
    PiecesOrderd: c.PiecesOrderd,
    TotalShipped: c.TotalShipped,
    PiecesShipped: c.PiecesShipped,
    RequestedShipDate: c.RequestedShipDate,
    ScheduledShipDate: c.ScheduledShipDate,
    ActualShipDate: c.ActualShipDate,
    CarrierCode: c.CarrierCode,
    CarrierName: c.CarrierName,
    ExternalOrderNo: c.ExternalOrderNo,
    BOLNumber: c.BOLNumber,
    BillTo: c.BillTo,
    ShipTo: c.ShipTo,
    ConsigneeAddress: c.ConsigneeAddress,
    PurchaseOrder: c.PurchaseOrder,
    tracking_PROnumber: c.tracking_PROnumber,
    AppointmentNumber: c.AppointmentNumber,
    Door: c.Door,
    Route: c.Route,
    Stop: c.Stop,
    LoadNumber: c.LoadNumber,
    TrailerNumber: c.TrailerNumber,
    sourceBOLFile: c.sourceBOLFile,
    signedBOLFile: c.signedBOLFile,
    BuyerPOnumber: c.BuyerPOnumber
  }));

  const getDetailPanelContent = React.useCallback(
    ({ row }) => <OpenOrderDetailPanel row={row} data={detailData}/>,
    [data]
  );

  const handleSearch = () => {
    fetchTableData()
  }

  const clearForm = () => {
    setPONumber('');
    setCustomerOrder('');
    setItemNum('');
    setFormStatus('all');
    setTrackingNumber('');
    setBolNumber('')
    setClearFormData(true);
  }
  useEffect(() => {
    if(clearFormData) {
      fetchTableData()
    }
  }, [clearFormData])

  const getStatus = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    let payload = {
      masterListFor: 'orderStatus',
      whseCode: userSetting?.[0]?.currWarehouse,
    };
    const response = await postRequest(
      "user/Get_MasListVals",
      payload,
      headers
    );

    setStatusMenu(response.data.Payload.Table)
  }

  useEffect(() => {
    getStatus();
  }, [])

  return (
    <>
      <div>
          <Grid container spacing={2}>
            
            <Grid item xs= {12} md= {4}>
              <FormLabel htmlFor="po-number" sx={{fontSize:"0.9rem"}} >
                PO Number
              </FormLabel>
              <div>
              <OutlinedInput
                name="po-number"
                placeholder="Enter PO Number"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                onChange={(e) => setPONumber(e.target.value)}
                value={poNumber}
              />
              </div>
            </Grid>
            <Grid item xs= {12} md= {4}>
              <FormLabel htmlFor="item-number" sx={{fontSize:"0.9rem"}}>
                Item Number
              </FormLabel>
              <div>
              <OutlinedInput
                name="item-number"
                placeholder="Enter Item Number"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={itemNum}
                onChange={(e) => setItemNum(e.target.value)}
              />
              </div>
            </Grid>
            <Grid item xs= {12} md= {4}>
              <FormLabel htmlFor="status" sx={{fontSize:"0.9rem"}}>
                Status
              </FormLabel>
              <div>
              <Select
                SelectDisplayProps={{ style: { paddingTop: 8, paddingBottom: 8 } }}
                labelId="status"
                id="status"
                value={formStatus}
                onChange={(e) => setFormStatus(e.target.value)}
                fullWidth
                inputProps={{
                  style: {
                    maxHeight: "0.3rem",
                  },
                }}
              >
                <MenuItem value="all">All</MenuItem>
                {statusMenu.map( item => <MenuItem value={item.value}>{item.text}</MenuItem>)}
              </Select>
              </div>
            </Grid>
            <Grid item xs= {12} md= {4}>
              <FormLabel htmlFor="Customer-Order" sx={{fontSize:"0.9rem"}}>
                Customer Order
              </FormLabel>
              <div>
              <OutlinedInput
                name="Customer-Order"
                placeholder="Enter Customer Order"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={customerOrder}
                onChange={(e) => setCustomerOrder(e.target.value)}
              />
              </div>
            </Grid>
            <Grid item xs= {12} md= {4}>
              <FormLabel htmlFor="tracking-number" sx={{fontSize:"0.9rem"}}>
                Tracking Number
              </FormLabel>
              <div>
              <OutlinedInput
                name="tracking-number"
                placeholder="Enter Tracking Number"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
              />
              </div>
            </Grid>
            <Grid item xs= {12} md= {4}>
              <FormLabel htmlFor="bol-number" sx={{fontSize:"0.9rem"}}>
                BOL Number
              </FormLabel>
              <div>
              <OutlinedInput
                name="bol-number"
                placeholder="Enter BOL Number"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={bolNumber}
                onChange={(e) => setBolNumber(e.target.value)}
              />
              </div>
            </Grid>

          <Grid item xs= {12} md= {12} >
            <Stack direction="row" spacing={2}>
              <Button color="grey"  variant="contained" onClick={clearForm} size="small">Reset</Button>
              <Button variant="contained" onClick={handleSearch} size="small">
                Apply Filter
              </Button>
            </Stack>
          </Grid>

          </Grid>
        </div>
      <div
        style={{
          height: 700,
          width: "100%",
          marginTop: "20px",
          background: "#fff",
        }}
      >
        <DataGridPremium
          loading={isLoading}
          slots={{ toolbar: CustomToolbar }}
          
          columns={columns}
          rows={rows}
          getDetailPanelHeight={() => 400}
          getDetailPanelContent={getDetailPanelContent}
          sx={{
            "& .MuiDataGrid-detailPanel": {
              overflow: "visible",
            },
            "& .MuiButton-text": { fontSize:  "14px"}
          }}
          pagination
          pageSizeOptions={[30,50, 100, 200]}
          initialState={{pagination: { paginationModel: { pageSize: 50 } }}}
        ></DataGridPremium>
      </div>
    </>
  );
};

export default OpenOrderReportTable;
